import { render } from "./PostEditor.vue?vue&type=template&id=22df55e8"
import script from "./PostEditor.vue?vue&type=script&lang=js"
export * from "./PostEditor.vue?vue&type=script&lang=js"

import "./PostEditor.vue?vue&type=style&index=0&id=22df55e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__